import React from 'react';
import { motion } from 'framer-motion';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaGraduationCap, FaUniversity } from 'react-icons/fa';
import './Education.css';

const Education = () => {
  const educationData = [
    {
      type: 'academic',
      title: 'B.Tech Computer Science & Engineering (AI & Data Science)',
      institution: 'Hindustan Institute of Technology & Science, Chennai',
      period: '2023 - 2027 (3rd Year)',
      description: 'Specialized in Artificial Intelligence and Data Science with focus on machine learning, deep learning, and data analytics.',
      icon: FaUniversity,
      color: '#667eea'
    },
    {
      type: 'academic',
      title: 'Class XII',
      institution: 'State Board, Tamil Nadu',
      period: '2023',
      description: 'Completed higher secondary education with focus on science and mathematics.',
      icon: FaGraduationCap,
      color: '#764ba2'
    },
    {
      type: 'academic',
      title: 'Class X',
      institution: 'State Board, Tamil Nadu',
      period: '2021',
      description: 'Completed secondary education with excellent academic performance.',
      icon: FaGraduationCap,
      color: '#667eea'
    }
  ];

  return (
    <section className="education section" id="education">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Education</h2>
          <p className="section-subtitle">My journey in the Academics</p>
        </motion.div>

        <div className="education-timeline">
          <VerticalTimeline>
            {educationData.map((item, index) => (
              <VerticalTimelineElement
                key={index}
                className="vertical-timeline-element--work"
                contentStyle={{
                  background: 'var(--surface, #171a21)',
                  color: 'var(--text, #e6e9ef)',
                  boxShadow: '0 5px 20px rgba(0, 0, 0, 0.3)',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 255, 255, 0.07)'
                }}
                contentArrowStyle={{ borderRight: '7px solid var(--surface, #171a21)' }}
                date={item.period}
                iconStyle={{
                  background: item.color,
                  color: '#fff',
                  boxShadow: '0 0 0 3px var(--bg, #0f1115), 0 0 0 6px rgba(214, 255, 62, 0.2)'
                }}
                icon={<item.icon />}
              >
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <h3 className="education-title">{item.title}</h3>
                  <h4 className="education-institution">{item.institution}</h4>
                  <p className="education-description">{item.description}</p>
                  <div className="education-type">
                    <span className="type-badge">{item.type}</span>
                  </div>
                </motion.div>
              </VerticalTimelineElement>
            ))}
          </VerticalTimeline>
        </div>

        <motion.div
          className="education-note"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <p>
            My academic journey has been marked by continuous learning and growth,
            providing me with a strong foundation for my professional career.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Education; 